import { render, staticRenderFns } from "./AddSchoolForAdmin.vue?vue&type=template&id=934a2eb0&scoped=true"
import script from "./AddSchoolForAdmin.vue?vue&type=script&lang=js"
export * from "./AddSchoolForAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddSchoolForAdmin.vue?vue&type=style&index=0&id=934a2eb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934a2eb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('934a2eb0')) {
      api.createRecord('934a2eb0', component.options)
    } else {
      api.reload('934a2eb0', component.options)
    }
    module.hot.accept("./AddSchoolForAdmin.vue?vue&type=template&id=934a2eb0&scoped=true", function () {
      api.rerender('934a2eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/admin/AddSchoolForAdmin.vue"
export default component.exports